/**
 * @note 如果需要增加或者删除语言，同时需要修改@/compontents/public/lang.vue里面相关的语言配置
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zhCnLocale from 'element-ui/lib/locale/lang/zh-CN'
import zhTwLocale from 'element-ui/lib/locale/lang/zh-TW'
import enUsLocale from 'element-ui/lib/locale/lang/en'
import customZhCn from './lang/zh-CN'
import customZhTw from './lang/zh-TW'
import customEnUs from './lang/en-US'

Vue.use(VueI18n)

// 自动根据浏览器系统语言设置语言
/* const navLang = navigator.language
const localLang = (navLang === 'zh-CN' || navLang === 'zh-TW' || navLang === 'en-US') ? navLang : false
const lang = localStorage.getItem('local') || localLang  || 'zh-CN' */

//根据域名进行语言设置
let lang = localStorage.getItem('local') || "";
if (!lang) {
  if (/.cn$/.test(window.location.hostname)) {
    lang = lang || 'zh-CN'
  } else {
    lang = lang || 'en-US'
  }
}

Vue.config.lang = lang
localStorage.setItem('local', lang)
// vue-i18n 6.x+写法
Vue.locale = () => {}
const messages = {
  'zh-CN': Object.assign(zhCnLocale, customZhCn),
  'zh-TW': Object.assign(zhTwLocale, customZhTw),
  'en-US': Object.assign(enUsLocale, customEnUs)
}
const i18n = new VueI18n({
  locale: 'zh-CN',
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/locale/index.js